import React, { useEffect, useState } from 'react';
import SpinnerService from '../../services/SpinnerService';

//styles
import styles from './SizingTools.module.scss';
import SystemService from '../../services/SystemService';
import { Part } from '../../models/Api';

export default function LegacySizingTool(props: { iframeUrl: string; part?: Part }) {
  const [isSizingDataCreated, setIsSizingDataCreated] = useState(false);
  useEffect(() => {
    if (props.part) 
      SystemService.createPartSizingData(props.part).then(() => setIsSizingDataCreated(true));
    else
      setIsSizingDataCreated(true);
  }, []);

  return isSizingDataCreated ? (
    <div className={styles['sizing-tool-container']}>
      <iframe
        id="sizingTabFrame"
        src={props.iframeUrl}
        className={styles['sizing-iframe']}
        onLoad={async () => {
          const frame = document.getElementById('sizingTabFrame') as HTMLIFrameElement;
          // Legacy sizing tool expects its parent (frame) to let it know is ready
          frame.contentWindow?.postMessage({ type: 'ready', data: 'parent' }, '*');
          // Send message to gather sizingTabFrame's height and receive it back in a 'frameHeight' message
          frame.contentWindow?.postMessage({ type: 'getHeight', data: '' }, '*');
          // Hide the spinner since the iframe should have some content rendered already
          SpinnerService.updateSpinnerStatus(0, true);
          // Get the latest state of the part from the API since legacy code updated some info like workflow step
          if (props.part) {
            await SystemService.getPartsDetail(props.part.id as string);
          }
        }}
      />
    </div>
  ) : (
    <></>
  );
}
